import { ReturnApi } from './../model/Common.model';
import { Injectable, Inject, Compiler } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment, ADFS } from "../../environments/environment";
import { UserLogin, AdLoginRequest } from "../model/user.model";


const API_URL = environment.R3_GI_Reverse;
const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};
let BASEURL = '';
@Injectable()
export class AuthenService {

  currentLanguage: any;
  constructor(
    private readonly _compiler: Compiler,
    private readonly http: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    BASEURL = baseUrl;
  }

  login(request: AdLoginRequest): Observable<ReturnApi> {
    return this.http.post<ReturnApi>(BASEURL + 'api/authentication/login', request, httpOptions).pipe(
      tap((user: any) => {
      }),
      catchError(this.handleError<ReturnApi>('Login Err'))
    );
  }
  logout() {
    window.localStorage.removeItem('currentUser');
    this._compiler.clearCache();
    location.href = ADFS.logoutUrl;
  }


  verify(): Observable<boolean> {
    return this.jwt() ? this.http.post<ReturnApi>(BASEURL + 'api/authentication/verify', null, this.jwt())
      .pipe(
        tap((response: ReturnApi) => {
          this.log(`verify`); console.log(response);
        }),
        map(
          res => res.Success ? res.Data : false,
          () => false
        )
      ) : of(false)

  }

  getIpAddress() {
    return this.http
      .get('https://jsonip.com')
      .pipe(
        tap((response: any) => this.log(`GetIPAddress`)),
        catchError(this.handleError('IPAddress', []))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      this.log(`${operation} failed: ${error.message}`);
      // Ensure result is always of type T
      return of(result as T);
    };
  }

  private log(message: string) {
    // console.log(message);
    // this.messageService.add('JobSafetySettingService: ' + message);
  }


  private jwt() {
    // create authorization header with jwt token
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.token) {
      // let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + currentUser.token });

      let hOptions = {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + currentUser.token
          }
        )
      };
      return hOptions;
    }
  }
  errorHandl(error: { error: { message: string; }; status: any; message: any; }) {
    return throwError(error);
  }
}
